__turbopack_context__.v({
  "UsageTabCard": "AnsimUsage-module-scss-module__orPtHW__UsageTabCard",
  "ansimUsage": "AnsimUsage-module-scss-module__orPtHW__ansimUsage",
  "consultationButton": "AnsimUsage-module-scss-module__orPtHW__consultationButton",
  "consultationButtonWrapper": "AnsimUsage-module-scss-module__orPtHW__consultationButtonWrapper",
  "container": "AnsimUsage-module-scss-module__orPtHW__container",
  "contractTabs": "AnsimUsage-module-scss-module__orPtHW__contractTabs",
  "default": "AnsimUsage-module-scss-module__orPtHW__default",
  "inner": "AnsimUsage-module-scss-module__orPtHW__inner",
  "selected": "AnsimUsage-module-scss-module__orPtHW__selected",
  "tabContent": "AnsimUsage-module-scss-module__orPtHW__tabContent",
  "titleContent": "AnsimUsage-module-scss-module__orPtHW__titleContent",
  "usageArrow": "AnsimUsage-module-scss-module__orPtHW__usageArrow",
  "usageCards": "AnsimUsage-module-scss-module__orPtHW__usageCards",
  "usageContent": "AnsimUsage-module-scss-module__orPtHW__usageContent",
  "usageDescription": "AnsimUsage-module-scss-module__orPtHW__usageDescription",
  "usageSwiper": "AnsimUsage-module-scss-module__orPtHW__usageSwiper",
  "usageSwiperSlide": "AnsimUsage-module-scss-module__orPtHW__usageSwiperSlide",
  "visited": "AnsimUsage-module-scss-module__orPtHW__visited",
  "wrap": "AnsimUsage-module-scss-module__orPtHW__wrap",
});
